import { render, staticRenderFns } from "./SidebarBrands.vue?vue&type=template&id=309e237d&scoped=true"
import script from "./SidebarBrands.vue?vue&type=script&lang=js"
export * from "./SidebarBrands.vue?vue&type=script&lang=js"
import style0 from "./SidebarBrands.vue?vue&type=style&index=0&id=309e237d&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309e237d",
  null
  
)

export default component.exports